/**
 * PLAT-11601 — the Replace Term selection limit and its explanations.
 *
 * Each transcript word is tied to a timestamp, so a replacement wider than a
 * handful of words drifts out of sync with the audio; the limit itself is a
 * product decision and stays at five. What changed is how the limit shows up:
 * the menu row is disabled with the reason below instead of vanishing.
 */
export const REPLACE_TERM_WORD_LIMIT = 5;

export const REPLACE_TERM_LIMIT_REASON = `Replace up to ${REPLACE_TERM_WORD_LIMIT} words at a time. Split longer changes into smaller selections`;

/** Replace Term on a translated language points at the tool that does work there. */
export const TRANSLATED_REPLACE_TERM_REASON =
  'Use Fix Translation to change translated text';

/**
 * Words in a selection, counting any run of whitespace as one separator. The
 * old `split(' ')` made a double or trailing space count as a word, which is
 * why the limit felt like "sometimes 4, sometimes 5". No selection → 0.
 */
export function countSelectedWords(
  selection: Pick<Selection, 'toString'> | null | undefined,
): number {
  const text = selection?.toString().trim() ?? '';
  return text ? text.split(/\s+/).length : 0;
}
